import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './additionalExpenseForm';
import List from './additionalExpenseList';

const settings = {
    pathRegister: paths.additionalExpenseRegister,
    pathList: paths.additionalExpense,
    apiPath: 'additional-expense',
    permissionAdmin: null,
    title: 'Despesas adicionais',
    entity: 'additionalExpense',
};

const AdditionalExpense: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={{ ...settings, title: 'Despesa adicional' }} />
        </MainContainer>
    );
};

const AdditionalExpenseList: React.FC = () => {
    return (
        <MainContainer>
            <List settings={settings} />
        </MainContainer>
    );
};

export { AdditionalExpense, AdditionalExpenseList };
